import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { colors, spacing, typography } = themeVariables;

export const list = css`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  background: var(${colors.page.default});
  width: max-content;
`;

export const item = css`
  font-family: var(${typography.body.fontFamily});
  font-size: var(${typography.body.sizes.lg.fontSize});
  line-height: var(${typography.body.sizes.lg.lineHeight});
  letter-spacing: var(${typography.body.letterSpacing});
  color: var(${colors.content.secondary});
  margin: 0;
  padding: 0;
  flex-shrink: 0;
  white-space: nowrap;
`;

export const link = css`
  background: none;
  border: 0;
  padding: var(${spacing.md});
  cursor: pointer;
  font: inherit;
  letter-spacing: var(${typography.body.letterSpacing});
  text-decoration: none;
  color: var(${colors.content.secondary});
  font-weight: normal;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  border-bottom: 1px solid transparent;

  /* Pre-allocate space for bold text to prevent layout shift on hover */
  &::after {
    content: attr(data-text);
    font-weight: 700;
    height: 0;
    visibility: hidden;
    overflow: hidden;
    user-select: none;
    pointer-events: none;
  }

  &:hover {
    border-bottom: 2px solid var(${colors.stroke.selected});
    color: var(${colors.content.default});
    font-weight: 700;
  }
`;

export const activeItem = css`
  font: inherit;
  text-decoration: none;
  color: var(${colors.content.default});
  font-weight: 700;
  display: inline-block;
  border-bottom: 2px solid var(${colors.content.default});
  padding: var(${spacing.md});
  letter-spacing: var(${typography.body.letterSpacing});
`;
